"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
// import PropTypes from 'prop-types';
// Composants Material UI
var Button_1 = __importDefault(require("@mui/material/Button"));
var LinearProgress_1 = __importDefault(require("@mui/material/LinearProgress"));
// Composants génériques
var S_Saves_1 = __importDefault(require("./S_Saves"));
// Styles
require("./Saves.css");
function Saves(props) {
    // props
    var debug = props.debug, storageKeyPrefix = props.storageKeyPrefix, storageKeys = props.storageKeys, shareTitle = props.shareTitle, className = props.className;
    // state
    var _a = (0, react_1.useState)(undefined), localStorageSize = _a[0], setLocalStorageSize = _a[1];
    var _b = (0, react_1.useState)(undefined), localStorageSizeDatas = _b[0], setLocalStorageSizeDatas = _b[1];
    var _c = (0, react_1.useState)(undefined), tmpAllDatas = _c[0], setTmpAllDatas = _c[1];
    var _d = (0, react_1.useState)(false), canShare = _d[0], setCanShare = _d[1];
    // const
    // const STORAGE_KEYS = [S_Items.STORAGE_KEY_ITEMS,S_Models.STORAGE_KEY_MODELS];
    S_Saves_1.default.setStorageKeyPrefix(storageKeyPrefix);
    // chargement des donnees
    (0, react_1.useEffect)(function () {
        S_Saves_1.default.checkLocalStorageSize(function () {
            S_Saves_1.default.readLocalStorageSize(function (sizeinKb) {
                setLocalStorageSize(sizeinKb);
            });
            S_Saves_1.default.readLocalStorageSizeEffective(storageKeys, function (sizeInB) {
                setLocalStorageSizeDatas(sizeInB);
            });
        });
        if (window.navigator.share) {
            setCanShare(true);
        }
    }, []);
    // autres variables
    function extractAllDatas() {
        S_Saves_1.default.getLocalStorageDatasStringified(storageKeys, function (all) {
            setTmpAllDatas(all);
            var shareData = {
                title: shareTitle,
                text: all
            };
            if (canShare) {
                window.navigator.share(shareData)
                    .then(function () { return console.log('Share was successful.'); })
                    .catch(function (error) { return console.log('Sharing failed', error); });
            }
            else {
                console.log("Your system doesn't support sharing files.");
            }
        });
    }
    var progress = localStorageSize !== undefined && localStorageSize > 0 && localStorageSizeDatas !== undefined ? Math.round(localStorageSizeDatas / 1024) * 100 / localStorageSize : 0;
    var datasSize = localStorageSizeDatas !== undefined ? Math.round(localStorageSizeDatas / 1024) : 0;
    // if(!!debug) console.log('progress',progress);
    // if(!!debug) console.log('datasSize',datasSize);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: 'saves ' + className }, { children: [(0, jsx_runtime_1.jsx)("h2", __assign({ className: "primary" }, { children: "Sauvegardes" }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "saves-status" }, { children: ["Espace de stockage : ", (0, jsx_runtime_1.jsxs)("strong", { children: [progress, " %"] }, void 0), " ", (0, jsx_runtime_1.jsx)("small", { children: (0, jsx_runtime_1.jsxs)("i", { children: ["(", Math.round(localStorageSizeDatas / 1024), "Kb / ", localStorageSize, "Kb)"] }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(LinearProgress_1.default, { variant: "determinate", value: progress }, void 0)] }), void 0), canShare ? ((0, jsx_runtime_1.jsx)(Button_1.default, __assign({ variant: "outlined", fullWidth: true, onClick: extractAllDatas }, { children: "R\u00E9cup\u00E9rer toutes les donn\u00E9es stock\u00E9es" }), void 0)) : null] }), void 0));
}
exports.default = Saves;
//# sourceMappingURL=Saves.js.map